import {
  RECIPE_PROCESSING_SOURCE_ADD_TO_MEAL_TIME,
  RECIPE_PROCESSING_SOURCE_EXTRA_FOOD,
} from "@/features/meal-plan/constants/extra-food";
import { Body_add_your_food_api_v1_meals_your_food_post } from "@/clients/models/Body_add_your_food_api_v1_meals_your_food_post";

export type AddFoodModalMode = "default" | "extra-food" | "add-to-meal-time";

interface BuildRecipeProcessingRouteParams {
  mealId: string;
  mode: AddFoodModalMode;
  day?: string;
  targetDate?: string;
  mealTime?: Body_add_your_food_api_v1_meals_your_food_post.meal_time;
}

export const buildRecipeProcessingRoute = ({
  mealId,
  mode,
  day,
  targetDate,
  mealTime,
}: BuildRecipeProcessingRouteParams) => {
  const searchParams = new URLSearchParams({
    mealId,
  });

  if (mode === "extra-food") {
    searchParams.set("source", RECIPE_PROCESSING_SOURCE_EXTRA_FOOD);
    if (day) {
      searchParams.set("day", day);
    }
    if (targetDate) {
      searchParams.set("targetDate", targetDate);
    }
  }

  if (mode === "add-to-meal-time") {
    searchParams.set("source", RECIPE_PROCESSING_SOURCE_ADD_TO_MEAL_TIME);
    if (day) {
      searchParams.set("day", day);
    }
    if (targetDate) {
      searchParams.set("targetDate", targetDate);
    }
    if (mealTime) {
      searchParams.set("mealTime", mealTime);
    }
  }

  return `/plans/recipe-processing?${searchParams.toString()}`;
};
